/**
 * useIsDispatcher - can the signed-in user stage manual stops and see customer contacts?
 *
 * Asks the database (public.is_dispatcher → recalls.assign_technicians or super_admin)
 * instead of checking role names, so a change to who counts as a dispatcher
 * (e.g. lead technicians) takes effect without a frontend release.
 */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase/client';
import { useAuth } from '@/features/auth/contexts/EnhancedAuthContext';

export const isDispatcherKeys = {
  all: ['auth', 'is-dispatcher'] as const,
  user: (userId: string) => [...isDispatcherKeys.all, userId] as const
};

export function useIsDispatcher(): { isDispatcher: boolean; isLoading: boolean } {
  const { session } = useAuth();
  const userId = session?.user?.id;
  const query = useQuery({
    queryKey: userId ? isDispatcherKeys.user(userId) : isDispatcherKeys.all,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('is_dispatcher');
      if (error) throw error;
      return data === true;
    },
    enabled: !!userId,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1
  });
  // Fail closed: hide dispatcher-only actions until the server says yes.
  return { isDispatcher: query.data === true, isLoading: query.isLoading };
}
